// IMPORTANT: Import polyfills FIRST before anything else
import './polyfills';

import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { logger } from './utils/logger';
import './styles/global.css';
import './styles/animations.css';
import './i18n/config'; // Initialize i18n
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Simple loading fallback for i18n
const I18nLoader = () => (
  <div style={{ 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center', 
    height: '100vh',
    background: 'var(--tg-theme-bg-color, #ffffff)',
    color: 'var(--tg-theme-text-color, #000000)'
  }}>
    <div style={{ textAlign: 'center' }}>
      <div style={{ 
        width: '48px', 
        height: '48px', 
        border: '4px solid rgba(102, 126, 234, 0.2)', 
        borderTopColor: '#667eea', 
        borderRadius: '50%', 
        animation: 'spin 0.8s linear infinite',
        margin: '0 auto 16px'
      }}></div>
      <p style={{ margin: 0, fontSize: '14px', opacity: 0.7 }}>Loading...</p>
    </div>
  </div>
);

root.render(
  <React.StrictMode>
    <Suspense fallback={<I18nLoader />}>
      <App />
    </Suspense>
  </React.StrictMode>
);

// Register service worker for caching
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        logger.debug('[SW] Registered:', registration);
      })
      .catch((error) => {
        logger.error('[SW] Registration failed:', error);
      });
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
